import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import '../pagination/pagination.css';
import Pagination from '../pagination/pagination';
import LeaseApiService from '../../services/apiService';
import { RiRefreshLine } from 'react-icons/ri';
import { FaFileCircleExclamation } from 'react-icons/fa6';
import { IoAddSharp } from 'react-icons/io5';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import CreateUnitMaster from './createUnit';
import UpdateUnitMaster from './updateUnitMaster';
import RangeChips from '../shared/rangeChips';
import SummaryStrip, { countBy, totalFrom } from '../shared/summaryStrip';
import { FiDownload, FiEye, FiEdit2, FiLock, FiPlus, FiRotateCcw, FiSearch } from 'react-icons/fi';
import '../customerMaster/customerListing.css';
import { useRange, fetchRanged, useCardFilter, valueTiles } from '../shared/rangedList';

const UnitListing = ({ releaseMode = false }) => {
  const apiService = new LeaseApiService();
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [enteredBy, setEnteredBy] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [FilterTab, setFilterTab] = useState(true);
  const [propertyList, setpropertyList] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [releasing, setReleasing] = useState(false);
  const [releaseConfirmRow, setReleaseConfirmRow] = useState(null);
  const [modalMode, setModalMode] = useState(null); // null | 'add' | 'edit' | 'view'
  const [modalRow, setModalRow] = useState(null);

  const [formData, setFormData] = useState({
    unitNo: '',
    unitMdal: '',
    UnitClass: '',
    propertyName: null,
    unitType: null,
    unitCategory: null,
    enteredBy: null,
  });

  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    getItems()
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    const permissions = storedPermissions?.filter(acc => acc.formName === "Unit Master RA");
    setPermissions(permissions[0]);
  }, []);

  useEffect(() => {
    const handleClickOutside = () => setContextMenu(null);
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    const loadPropertyDropdown = async () => {
      try {
        // UMUnitTypes/UMUnitCategories are confirmed to come back correctly
        // from UNIT_RA_MULTIDROP (Lease Finance, "um"-prefix keys).
        // UMProperties/UMEnteredBy are NOT returned by it at all (confirmed
        // empty live) - those come from GET_UNIT_MULTIDROP (main backend)
        // instead, with plain PascalCase keys.
        const params = new URLSearchParams();
        params.append('dropdownTypes', 'UMUnitTypes,UMUnitCategories');
        const res = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${params.toString()}`);
        const missingParams = new URLSearchParams();
        missingParams.append('dropdownTypes', 'UMProperties,UMEnteredBy');
        const missingRes = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${missingParams.toString()}`);
        setpropertyList(missingRes?.data?.dropdowns?.UMProperties || []);
        setEnteredBy(missingRes?.data?.dropdowns?.UMEnteredBy);
        setUnitTypeList(res?.data?.dropdowns?.umUnitTypes);
        setunitCategoryList(res?.data?.dropdowns?.umUnitCategories);

      } catch (e) {
        console.error('Error loading property list:', e);
      }
    };
    loadPropertyDropdown();
    getItems();
  }, []);

  const { range, setRange, cache: rangeCache } = useRange(() => getItems(1));
  const cf = useCardFilter(rowData, range, rangeCache);
  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      params.append('PropertyNo', formData?.propertyName?.value?.value || '');
      params.append('UnitNo', formData?.unitNo || '');
      params.append('UnitClass', formData?.UnitClass || '');
      params.append('UnitType', formData?.unitType?.label || '');
      params.append('UnitCategory', formData?.unitCategory?.label || '');
      params.append('CreatedBy', formData?.enteredBy?.label || '');
      params.append('UnitModel', formData?.unitMdal || '');
      const res = await fetchRanged({ apiService, endpoint: 'GET_UNIT_RA_LIST', params, range, cache: rangeCache, pageNo: newPageNo, pageSize });
      setLoading(false);
      setRowData(res?.data?.result || []);
      // The Lease Finance endpoint doesn't always return every paginationData
      // field the shared Pagination needs for its page numbers (only the
      // prev/next arrows render without totalPages), so derive the gaps.
      const pd = res?.data?.paginationData || {};
      const size = Number(pd.pageSize ?? pd.PageSize) || pageSize || 20;
      const totalRecords = Number(pd.totalRecords ?? pd.TotalRecords ?? pd.totalCount ?? pd.TotalCount) || (res?.data?.result || []).length;
      setPagination({
        ...pd,
        currentPage: Number(pd.currentPage ?? pd.CurrentPage ?? pd.pageNo ?? pd.PageNo) || newPageNo || 1,
        totalRecords,
        totalPages: Number(pd.totalPages ?? pd.TotalPages) || Math.max(1, Math.ceil(totalRecords / size)),
      });
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };
  const columnDefs = [
    {
      headerName: '',
      field: 'scheduleId',
      cellRenderer: BtnCellRenderer,
      pinned: 'left',
      cellRendererParams: {
        clicked: function (field, scheduleId) {
          handleMenuAction(field, scheduleId);
        },
      },
      width: 130,
      suppressMovable: true,
      sortable: false,
      filter: false,
    },
    { headerName: 'Ref no', field: 'ref_No', filter: true, floatingFilter: true, suppressMovable: true, width: 150, pinned: 'left' },
    { headerName: 'Property Name', field: 'property_Name', filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
    { headerName: 'Unit No', field: 'unit_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Type', field: 'unit_Type', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Category', field: 'unit_Category', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Class', field: 'unit_Class', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Status', field: 'status', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'BedRooms', field: 'bedrooms', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Total Area', field: 'total_Area', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Floor', field: 'floor', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit View', field: 'unit_View', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Rate / Sqft', field: 'sqft_Rate', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Rent / Annum', field: 'rent_Per_Annum', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Property No', field: 'property_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
  ];
  const handleMenuAction = (action, rowData) => {
    switch (action) {
      case 'edit':
        handleEdit(rowData);
        break;
      case 'release':
        openReleaseConfirm(rowData);
        break;
      case 'view':
        handleView(rowData);
        break;
      default:
        break;
    }
    setContextMenu(null);
  };
  const handleEdit = (rowData) => {
    setModalRow(rowData);
    setModalMode('edit');
  };
  const handleView = (rowData) => {
    setModalRow(rowData);
    setModalMode('view');
  };
  const closeModal = () => {
    setModalMode(null);
    setModalRow(null);
    getItems();
  };
  const openReleaseConfirm = (rowData) => {
    const refNo = rowData?.ref_No;
    if (!refNo) {
      toast.warning('Release no is missing');
      return;
    }
    setReleaseConfirmRow(rowData);
  };
  const closeReleaseConfirm = () => {
    if (!releasing) setReleaseConfirmRow(null);
  };
  const confirmRelease = async () => {
    const refNo = releaseConfirmRow?.ref_No;
    if (!refNo) return;

    try {
      setReleasing(true);
      const res = await apiService.put('RELEASE_UNIT_BLOCKING', {
        refNo,
        releasedDate: new Date().toISOString(),
      });
      if (res?.data?.isSuccessful || res?.data?.result === true) {
        toast.success(res?.data?.message || 'Unit released successfully');
        setReleaseConfirmRow(null);
        getItems(pagination?.currentPage || 1);
      } else {
        toast.warning(res?.data?.message || 'Release failed');
      }
    } catch (error) {
      console.error('Error releasing unit:', error);
      toast.error(error?.response?.data?.message || 'Failed to release unit');
    } finally {
      setReleasing(false);
    }
  };
  const handleClearFilters = () => {
    setFormData({
      unitNo: '',
      unitMdal: '',
      UnitClass: '',
      propertyName: null,
      unitType: null,
      unitCategory: null,
      enteredBy: null,
    });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleDropDownChange = async ({ name, value }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handlenew = () => {
    setModalRow(null);
    setModalMode('add');
  };
  return (
    <div className="unit-ra-list-page cl-page">
      <div className="cl-titlebar">
        <div className="cl-title">
          <h1>{releaseMode ? 'Unit Release' : 'Unit Listing'}</h1>
          <p>Search, review and manage units across your properties.</p>
        </div>
        <RangeChips value={range} onChange={setRange} />
      </div>
      <SummaryStrip
        label="Total units"
        total={totalFrom(pagination, rowData.length)}
        subtitle="All properties"
        heroNote={cf.inPeriod ? 'Chosen period' : 'All records'} heroActive={!cf.filter} onHero={() => cf.setFilter(null)}
        tiles={[
          { label: cf.inPeriod ? 'In period' : 'On this page', value: cf.statsRows.length, note: 'units', active: !cf.filter, onClick: () => cf.setFilter(null) },
          ...valueTiles(cf, 'status', 3),
          ...valueTiles(cf, 'unit_Class', 2),
        ]}
        ariaLabel="Unit summary"
      />
      <section className="cl-panel cl-filters" aria-label="Search parameters">
        <div>
          <div>
            <div className="form-group grid-contain ">
              <div className="d-flex">
                <label className="form-label pt-2 start">Property Name</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.propertyName}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'propertyName', value: selectedOption })}
                  options={propertyList?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Type</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.unitType}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'unitType', value: selectedOption })}
                  options={unitTypeList?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Category</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.unitCategory}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'unitCategory', value: selectedOption })}
                  options={unitCategoryList?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit No</label>
                <input type="text" className="p-2 form-control w-75" name="unitNo" value={formData.unitNo} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Entered By</label>
                <Select
                  className="p-0 w-100"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  value={formData?.enteredBy}
                  onChange={(selectedOption) => handleDropDownChange({ name: 'enteredBy', value: selectedOption })}
                  options={enteredBy?.map((prop) => ({ value: prop, label: prop?.text }))}
                />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Class</label>
                <input type="text" className="p-2 form-control w-75" name="UnitClass" value={formData.UnitClass} onChange={handleInputChange} />
              </div>
              <div className="d-flex">
                <label className="form-label pt-2 start">Unit Model</label>
                <input type="text" className="p-2 form-control w-75" name="unitMdal" value={formData.unitMdal} onChange={handleInputChange} />
              </div>
              <div className="cl-filter-actions">
                <button type="button" className="cl-btn cl-btn-ghost" onClick={() => handleClearFilters()}><FiRotateCcw size={16} />Reset</button>
                <button type="button" className="cl-btn cl-btn-primary" onClick={() => getItems()}><FiSearch size={16} />Search</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cl-panel cl-list">
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="cl-list-head">
              <h2>{releaseMode ? 'Unit Release' : 'Unit Listing'}</h2>
              {!releaseMode && permissions?.canAdd === true && (
                <button type="button" className="cl-btn cl-btn-primary" onClick={() => handlenew()}><FiPlus size={16} />Add</button>
              )}
            </div>
            <div className="cl-grid-wrap">
              <div className="ag-theme-quartz customer-grid" style={{ height: 650 }}>
                <AgGridReact
                  rowData={cf.filter ? cf.shownRows : rowData}
                  enableFilter={true}
                  floatingFilter={true}
                  columnDefs={columnDefs}
                  frameworkComponents={{ BtnCellRenderer }}
                  context={{ onAction: handleMenuAction, releaseMode, permissions, releasing }}
                />
              </div>
              {!cf.filter && <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />}
            </div>
          </>
        )}
        <Modal show={!!releaseConfirmRow} onHide={closeReleaseConfirm} centered>
          <Modal.Body className="text-center p-4">
            <p className="mb-4">Do you want to release the &quot;{releaseConfirmRow?.ref_No}&quot;?</p>
            <div className="d-flex justify-content-center gap-3">
              <button type="button" className="btn btn-primary px-4" disabled={releasing} onClick={confirmRelease}>
                Yes
              </button>
              <button type="button" className="btn btn-secondary px-4" disabled={releasing} onClick={closeReleaseConfirm}>
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={modalMode !== null}
          onHide={closeModal}
          backdrop="static"
          keyboard={false}
          centered
          dialogClassName="unit-form-modal"
          contentClassName="p-0"
        >
          <Modal.Body style={{ padding: 0 }}>
            {modalMode === 'add' && <CreateUnitMaster onClose={closeModal} />}
            {modalMode === 'edit' && <UpdateUnitMaster rowData={modalRow} onClose={closeModal} />}
            {/* View now reuses UpdateUnitMaster in read-only mode instead of the
                old ViewUnitMaster - that component was a separately-maintained
                copy that had drifted: wrong field casing throughout and only
                4 of the 9 tabs Create/Edit have (missing Sales Details, Buyer
                Summary, Lease Details, Advertisement, Payable). Reusing this
                component means View can't drift out of sync again. */}
            {modalMode === 'view' && <UpdateUnitMaster rowData={modalRow} onClose={closeModal} viewOnly />}
          </Modal.Body>
        </Modal>
      </section>
    </div>
  );
};
export default UnitListing;
// Row actions as icons: view / edit (Unit Listing) or view / release (Unit Release), gated by the user's permissions.
const BtnCellRenderer = ({ data, context }) => {
  const { onAction, releaseMode: rel, permissions: perm, releasing: busy } = context || {};
  return (
    <div className="cl-actions">
      {perm?.canView === true && (
        <button type="button" className="cl-ico" title="View" aria-label="View" onClick={() => onAction('view', data)}><FiEye size={18} /></button>
      )}
      {!rel && perm?.canUpdate === true && (
        <button type="button" className="cl-ico" title="Edit" aria-label="Edit" onClick={() => onAction('edit', data)}><FiEdit2 size={18} /></button>
      )}
      {rel && (
        <button type="button" className="cl-ico" title="Release" aria-label="Release" disabled={busy} onClick={() => onAction('release', data)}><FiLock size={18} /></button>
      )}
    </div>
  );
};
